import { Module } from 'vuex';
import { actions } from '@/onboarding-sidebar/store/onboarding.actions';
import { mutations } from '@/onboarding-sidebar/store/onboarding.mutations';
import { getters } from '@/onboarding-sidebar/store/onboarding.getters';
import { RootState } from '@/store/store';
import { state, IOnboardingState } from '@/onboarding-sidebar/store/onboarding.constants';

const namespaced = true;

export const onboarding: Module<IOnboardingState, RootState> = {
  state,
  namespaced,
  actions,
  mutations,
  getters,
};
